module.exports = __webpack_public_path__ + "img/sms-logo.png";